var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dashboard",
    transform: "translate(-1310.000000, -268.000000)",
    fill: "#B2B1AD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile",
    transform: "translate(1170.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/copy",
    transform: "translate(140.375000, 148.375000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.8125,0 L2.2494375,0.5625 L2.2494375,2.25 L0.5619375,2.25 L0,2.8119375 L0,10.6875 L0.5619375,11.25 L8.4375,11.25 L9,10.6875 L9,9 L10.6869375,9 L11.2494375,8.4369375 L11.2494375,0.5625 L10.6869375,0 L2.8125,0 Z M3.375,7.875 L10.125,7.875 L10.125,1.125 L3.375,1.125 L3.375,7.875 Z M1.1244375,3.3744375 L2.2494375,3.3744375 L2.2494375,8.4369375 L2.8125,9 L7.875,9 L7.875,10.125 L1.1244375,10.125 L1.1244375,3.3744375 Z",
    id: "icon"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.a72512c7a6d17b49206afde66bc2b12c.svg";
export { ForwardRef as ReactComponent };